import qs from 'query-string';
import { useRef } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { CMS_BASE_URL, SPA_BASE_URL } from '@/utils/constants';
import { Page as BrPage } from '@bloomreach/spa-sdk';
import { computeCMSSearchRedirect } from './useCMSSearchLocation.logic';

export const useCMSSearchLocation = (page: BrPage) => {
  const needsPageLoadRedirectTest = useRef(true);
  const { pathname } = useLocation();
  const { replace } = useHistory();
  const appPath = pathname.endsWith('/') ? pathname : `${pathname}/`;
  const pageUrl = page?.getUrl() || '';

  if (needsPageLoadRedirectTest.current) {
    const { shouldRedirect, redirectPath, redirectQuery } = computeCMSSearchRedirect({
      appPath,
      pageUrl,
      CMS_BASE_URL,
      SPA_BASE_URL,
    });
    needsPageLoadRedirectTest.current = false;

    if (shouldRedirect) {
      replace(`${redirectPath}${redirectQuery && `?${redirectQuery}`}`);
      return { isSearch: true, appPath: redirectPath };
    }
  }

  return { isSearch: appPath.endsWith('search/'), appPath };
};
